/* eslint-disable array-callback-return */
import React, { useEffect, useState, useCallback } from "react";
import DashboardPage from "../../layout";
import { getCustomerCreationReport } from "../../api/supervisor";
import { getGlobalFilter } from "../../api/filters";
import PaginationComponent from "../../components/Pagination";
import Loader from "../../components/Loader";
import Filter from "../../assets/icons/Filter.svg";
import {
    formatCurrentStartDate,
    formatCurrentEndDate,
    getPagePerSize,
} from "../../utility";
import TimeFrameSelector from "../../components/TimeFrameSelector";
import { formatDate } from "../../utility";
import Dropdown from "../../components/Dropdown";
import DropdownMulti from "../../components/DropdownMultiple";
import moment from "moment";
import { useTranslation } from "react-i18next";
import Close from "../../assets/close-circle.svg";
import Search from "../../assets/Search.svg";
import Eye from "../../assets/eye.svg";
import { useNavigate } from "react-router-dom";
import URL_MAPPING from "../../routes/constants";
import { TimeZoneDisplay } from "../../utility";
import Button from "../../components/Button";
import debounce from "lodash/debounce";
import { toast, ToastContainer } from "react-toastify";
import PlanogramPopup from "../../components/PlanogramPopup";
import { preseller, salesman ,sdr } from "../../utility/constant";

const CustomerCreationReport: React.FC = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [searchQuery, setSearchQuery] = useState("");
    const [open, setOpen] = useState(false);
    const [employees, setEmployeesData] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    const [loadingFilter, setLoadingForFilter] = useState(false);
    const [timeFrame, setSelectTimeFrame] = useState<any>("Today");
    const [startDate, setStartDate] = useState<any>(new Date());
    const [endDate, setEndDate] = useState<any>(new Date());
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [sortType, setSortType] = useState<any>("");
    const { t } = useTranslation();
    const [globalFilters, setGlobalFilters] = useState<any>(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [selectedEmpId, setSelectedEmpId] = useState<any>([]);
    const [selectedEmpStatus, setSelectedEmpStauts] = useState<any>("");
    const [selectedSalesOffice, setSelectedSalesOffice] = useState<any>([]);
    const [selectedRegion, setRegion] = useState<any>([]);
    const [territoryId, setTerritoryId] = useState<any>([]);
    const [routeId, setRouteId] = useState<any>([]);
    const [userType, setUserType] = useState<any>("");
    const [channelId, setChannelId] = useState<any>([]);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [imgData, setImgData] = useState<{
        actualImage: string;
        processedImage?: string | null;
        comparisonImage?: string | null;
        imageType: string;
    } | null>(null);
    const startIndex = (currentPage - 1) * employees?.size;
    const navigate = useNavigate();
    const employeesPerPage = getPagePerSize();

    const getGlobalFilters = async (data: any) => {
        try {
            setLoadingForFilter(true);
            const response = await getGlobalFilter(data);
            setLoadingForFilter(false);
            setGlobalFilters(response);
        } catch (error) {
            console.error("Error fetching global filters:", error);
        }
    };
    const handleOpenPopup = (data: {
        actualImage: string;
        processedImage?: string | null;
        comparisonImage?: string | null;
        imageType: string;
    }) => {
        setImgData(data);
        setIsPopupOpen(true);
    };

    const handleClosePopup = () => {
        setIsPopupOpen(false);
        setImgData(null);
    };
    const handleFilterClick = () => {
        setOpen(true);
    };

    const handleChange = (event: any) => {
        updateSearchTerm(event);
        setSearchQuery(event);
    };

    const updateSearchTerm = useCallback(
        debounce((value: string) => {
            const data: any = {
                start_date: formatCurrentStartDate(new Date(startDate)),
                end_date: formatCurrentEndDate(new Date(endDate)),
            };

            if (value) {
                data["search"] = value;
            }
            getPayload(data);
            const params = {
                page: 1,
                size: employeesPerPage,
            };
            setCurrentPage(1);
            getEmployeesData(data, params);
        }, 500),
        [
            startDate,
            endDate,
            selectedEmpStatus,
            channelId,
            selectedRegion,
            routeId,
            selectedSalesOffice,
            selectedEmpId,
            territoryId,
            userType,
            sortType,
            employeesPerPage,
        ]
    );

    const handleSortFillter = (data: string) => {
        if (data === sortType) {
            setSortType("");
            handleApply("");
        } else {
            setSortType(data);
            handleApply(data);
        }

        setIsDropdownOpen(false);
    };

    function getCurrentDate() {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const handleClose = () => setOpen(false);

    const handleClearFilters = () => {
        setSelectedEmpId([]);
        setSelectedSalesOffice([]);
        setRegion([]);
        setTerritoryId([]);
        setRouteId([]);
        setUserType(null);
        setChannelId([]);
        setSelectedEmpStauts(null);
        setStartDate(getCurrentDate());
        setEndDate(getCurrentDate());
        setSelectTimeFrame("Today");
        setOpen(false);
        handleClearApply("");
    };

    const handleClearApply = (sort: string) => {
        const data: any = {
            start_date: formatCurrentStartDate(new Date()),
            end_date: formatCurrentEndDate(new Date()),
        };
        data["positions"] = [preseller, salesman,sdr];
        const params = {
            page: 1,
            size: employeesPerPage,
        };
        setCurrentPage(1);
        getEmployeesData(data, params);
        handleClose();
    };

    const handleExport = async () => {
        setLoading(true);
        const data: any = {
            start_date: formatCurrentStartDate(new Date(startDate)),
            end_date: formatCurrentEndDate(new Date(endDate)),
            export: true,
            time_zone: TimeZoneDisplay(),
        };

        if (searchQuery) {
            data["search"] = searchQuery;
        }
        if (sortType) {
            data["sort_by"] = sortType;
        }
        getPayload(data);
        const params = {};
        try {
            await exportActiviyData(data, params);
        } catch (error) {
            console.error("Error exporting data:", error);
        } finally {
            setLoading(false);
        }
    };

    const exportActiviyData = async (data: any, params: any) => {
        await getCustomerCreationReport(params, data)
            .then((res) => {
                toast.success(res?.message)
                // const url = window.URL.createObjectURL(new Blob([res]));
                // const a = document.createElement("a");
                // a.href = url;
                // a.download = `team_activity_report.csv`;
                // a.click();
                // a.remove();
                // window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
                console.error("Error fetching Employee data:", error);
                toast.warn(error?.response?.data?.detail)
            });
    };

    const getEmployeesData = async (data: any, params: any) => {
        setLoading(true);
        await getCustomerCreationReport(params, data)
            .then((res) => {
                setEmployeesData(res);
                setLoading(false);
            })
            .catch((error) => {
                console.error("Error fetching Employee data:", error);
                setLoading(false);
            });
    };

    const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setStartDate(e.target.value);
        checkTimeFrame(e.target.value, endDate);
    };

    const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEndDate(e.target.value);
        checkTimeFrame(startDate, e.target.value);
    };
    const formattedToday = formatDate(startDate)
    const handleRouteClick = (id: string | number) => {
        navigate(URL_MAPPING.MAPVIEW, {
            state: { id, selectDate: formattedToday },
        });
    };

    useEffect(() => {
        const data: any = {
            start_date: formatCurrentStartDate(new Date(startDate)),
            end_date: formatCurrentEndDate(new Date(endDate)),
        };

        if (searchQuery) {
            data["search"] = searchQuery;
        }

        getPayload(data);

        const params = {
            page: currentPage,
            size: employeesPerPage,
        };
        getEmployeesData(data, params);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentPage]);

    useEffect(() => {
        const data: any = {};

        if (selectedRegion.length > 0) {
            data["regions"] = selectedRegion;
        }
        if (selectedSalesOffice.length > 0) {
            data["sales_office_ids"] = selectedSalesOffice;
        }
        if (selectedEmpId.length > 0) {
            data["subordinate_ids"] = selectedEmpId;
        }
        if (territoryId.length > 0) {
            data["territory_ids"] = territoryId;
        }
        if (routeId.length > 0) {
            data["route_ids"] = routeId;
        }
        data["endpoint"] = "visit-summary";
        data["start_date"] = formatCurrentStartDate(new Date(startDate));
        data["end_date"] = formatCurrentEndDate(new Date(endDate));
        data["positions"] = [preseller, salesman];
        getGlobalFilters(data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleFiltersUpdate = () => {
        const data: any = {};

        if (selectedRegion.length > 0) {
            data["regions"] = selectedRegion;
        }
        if (selectedSalesOffice.length > 0) {
            data["sales_office_ids"] = selectedSalesOffice;
        }
        if (selectedEmpId.length > 0) {
            data["subordinate_ids"] = selectedEmpId;
        }
        if (territoryId.length > 0) {
            data["territory_ids"] = territoryId;
        }
        if (routeId.length > 0) {
            data["route_ids"] = routeId;
        }
        data["endpoint"] = "visit-summary";
        data["start_date"] = formatCurrentStartDate(new Date(startDate));
        data["end_date"] = formatCurrentEndDate(new Date(endDate));
        data["positions"] = [preseller, salesman];
        getGlobalFilters(data);
    };

    const getPayload = (data: any) => {
        if (selectedEmpStatus) {
            data["status"] = selectedEmpStatus;
        }

        if (channelId.length > 0) {
            data["channel_ids"] = channelId;
        }
        if (selectedRegion.length > 0) {
            data["regions"] = selectedRegion;
        }
        if (routeId.length > 0) {
            data["route_ids"] = routeId;
        }
        if (selectedSalesOffice.length > 0) {
            data["sales_office_ids"] = selectedSalesOffice;
        }
        if (selectedEmpId.length > 0) {
            data["subordinate_ids"] = selectedEmpId;
        }
        if (territoryId.length > 0) {
            data["territory_ids"] = territoryId;
        }
        if (userType) {
            data["user_type"] = userType;
        }
        data["positions"] = [preseller, salesman,sdr];
    };

    const handleApply = (sort: string) => {
        setCurrentPage(1);
        const data: any = {
            start_date: formatCurrentStartDate(new Date(startDate)),
            end_date: formatCurrentEndDate(new Date(endDate)),
        };
        if (searchQuery) {
            data["search"] = searchQuery;
        }
        getPayload(data);
        if (sort) {
            data["sort_by"] = sort;
        }
        const params = {
            page: 1,
            size: employeesPerPage,
        };

        getEmployeesData(data, params);
        handleClose();
    };

    const checkTimeFrame = (start: any, end: any) => {
        if (start === formatDate(new Date()) && end === formatDate(new Date())) {
            setSelectTimeFrame("Today");
        } else if (
            start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
            end === formatDate(new Date().setDate(new Date().getDate() - 1))
        ) {
            setSelectTimeFrame("Yesterday");
        } else if (
            start === formatDate(new Date().setDate(1)) &&
            end === formatDate(new Date())
        ) {
            setSelectTimeFrame("Month till date");
        } else {
            setSelectTimeFrame("");
        }
    };

    useEffect(() => {
        setSelectedSalesOffice("");
        setTerritoryId("");
        setRouteId("");
        setSelectedEmpId("");
    }, [selectedRegion]);

    useEffect(() => {
        setTerritoryId("");
        setRouteId("");
        setSelectedEmpId("");
    }, [selectedSalesOffice]);

    useEffect(() => {
        setRouteId("");
        setChannelId("");
        setSelectedEmpId("");
    }, [territoryId]);

    useEffect(() => {
        if (selectedEmpId) {
            globalFilters?.employees?.map((value: any) => {
                if (selectedEmpId === value.id) {
                    setUserType(value.position);
                }
            });
        } else {
            setUserType("");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedEmpId]);

    return (
        <DashboardPage>
            <div className="bg-white p-4 border-b-2">
  <h1 className="text-l font-bold text-gray-800">
    {t("supervisorCustomerCreationDetails.title")}
  </h1>
</div>
            <ToastContainer />
            <div className="bg-gray-50  sm:pl-0 pr-4 ">
                <div className="hidden mb-2 sm:flex flex-col sm:flex-row justify-between items-center bg-white p-2 border-b-2">
                    <div className="w-full sm:w-auto mb-4 sm:mb-0 pl-6">
                        <PaginationComponent
                            totalCount={employees?.total}
                            itemsPerPage={employees?.size}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    </div>

                    <div className="flex flex-col sm:flex-row items-center w-full sm:w-auto space-y-4 sm:space-y-0 sm:space-x-4">
                        <div className="relative w-full sm:w-auto">
                            <div className="absolute inset-y-0 left-0 flex items-center pl-3">
                                {/* Add your search icon here */}
                                <img src={Search} alt="search" />
                            </div>
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => handleChange(e.target.value)}
                                placeholder={t("planogram.searchPlaceholder")}
                                className="w-full sm:w-auto pl-10 pr-4 py-2 text-16 border rounded text-gray-600"
                                style={{ borderColor: "#e0e0e0" }}
                            />
                        </div>

                        {/* Buttons group for desktop */}
                        <div className="hidden sm:flex space-x-4 items-center">
                            {/* <button
                onClick={handleSort}
                className="flex items-center px-4 py-2 text-16 text-gray-600 rounded transition-all"
              >
                <img src={Sort} alt="Sort Icon" className="w-4 h-4 mr-2" />
                Sort by
              </button> */}
                            {isDropdownOpen && (
                                <ul className="absolute z-50 right-30 top-10 w-48 bg-white border border-gray-300 rounded shadow-lg">
                                    <li
                                        className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${sortType === "ASC" && "bg-lightgrey"
                                            }`}
                                        onClick={() => handleSortFillter("ASC")}
                                    >
                                        {t("planogram.ascending")}
                                    </li>
                                    <li
                                        className={`px-4 py-2 hover:bg-gray-100 cursor-pointer  ${sortType === "DESC" && "bg-lightgrey"
                                            }`}
                                        onClick={() => handleSortFillter("DESC")}
                                    >
                                        {t("planogram.descending")}
                                    </li>
                                </ul>
                            )}
                            <button
                                onClick={handleFilterClick}
                                className="flex items-center gap-2 px-4 py-2 text-13 font-normal rounded transition-all"
                            >
                                <img
                                    src={Filter}
                                    alt={t("planogram.filter")}
                                    className="w-4 h-4 mr-2"
                                />
                                {t("planogram.filter")}
                            </button>

                            {/* <button
                                onClick={handleExport}
                                className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                                    }`}
                                disabled={loading}
                            >
                                {loading ? (
                                    <span className="flex items-center gap-2">
                                        <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                                        {t("masterList.exporting")}
                                    </span>
                                ) : (
                                    <>
                                        {t("masterList.export")}
                                        <img
                                            src={Export}
                                            alt={t("masterList.export")}
                                            className="w-4 h-4 "
                                        />
                                    </>
                                )}
                            </button> */}
                        </div>
                    </div>
                </div>
                <div className="sm:hidden flex justify-between items-center p-2 border-b-2 bg-white">
                    <div className="flex-grow">
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            placeholder={t("planogram.searchPlaceholder")}
                            className="w-full px-4 py-2 text-13 border rounded text-gray-600"
                            style={{ borderColor: "#e0e0e0" }}
                        />
                    </div>

                    {/* Hamburger menu for Sort, Filter, Export */}
                    <div className="flex items-center space-x-2">
                        {/* <button
                            onClick={handleExport}
                            className={`flex items-center gap-2 px-4 py-2 text-13 font-medium border rounded transition-all ${loading ? "opacity-50 cursor-not-allowed" : ""
                                }`}
                            disabled={loading}
                        >
                            {loading ? (
                                <span className="flex items-center gap-2">
                                    <span className="loader w-4 h-4 border-2 border-t-2 border-gray-300 rounded-full animate-spin"></span>
                                    {t("masterList.exporting")}
                                </span>
                            ) : (
                                <>
                                    {t("masterList.export")}
                                    <img
                                        src={Export}
                                        alt={t("masterList.export")}
                                        className="w-4 h-4 "
                                    />
                                </>
                            )}
                        </button> */}

                        <button
                            className="px-2 py-2 text-gray-600 rounded transition-all"
                            onClick={() => setOpen(!open)}
                        >
                            <svg
                                className="w-6 h-6"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M4 6h16M4 12h16m-7 6h7"
                                ></path>
                            </svg>
                        </button>
                    </div>
                </div>
                {open && (
                    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end sm:items-start items-center z-50">
                        <div className="relative bg-white shadow-lg w-full max-w-md h-full">
                            <div className="absolute z-30 top-[50%] left-[45%]">
                                {loadingFilter && <Loader />}
                            </div>
                            <div className="flex justify-between p-6 border-b-2">
                                <div className="text-16 font-bold">
                                    {t("visitreports.filters.title")}
                                </div>
                                <div>
                                    <img
                                        className="cursor-pointer"
                                        onClick={() => setOpen(false)}
                                        src={Close}
                                        alt=""
                                    />
                                </div>
                            </div>
                            <div className="flex flex-col justify-between h-[calc(100vh-100px)] px-12 pt-6 overflow-y-auto scrollbar scrollbar-thin">
                                <div className="flex flex-col gap-[30px]">
                                    <div className="flex gap-4">
                                        <div className="w-1/2">
                                            <DropdownMulti
                                                label={t("visitreports.filters.region")}
                                                options={globalFilters?.regions.map((sales: any) => ({
                                                    value: sales,
                                                    label: sales,
                                                }))}
                                                selectedValues={selectedRegion}
                                                onClose={handleFiltersUpdate}
                                                showSelectAll={true}
                                                onChange={setRegion}
                                                placeholder={t("visitreports.filters.selectRegion")}
                                            />
                                        </div>
                                        <div className="w-1/2">
                                            <DropdownMulti
                                                label={t("visitreports.filters.salesOffice")}
                                                options={
                                                    globalFilters?.sales_offices.map((sales: any) => ({
                                                        value: sales.id,
                                                        label: sales.name,
                                                    })) || []
                                                }
                                                selectedValues={selectedSalesOffice}
                                                onClose={handleFiltersUpdate}
                                                showSelectAll={true}
                                                onChange={setSelectedSalesOffice}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t(
                                                    "visitreports.filters.selectSalesOffice"
                                                )}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex gap-4">
                                        {/* <div className="w-1/2">
                                            <DropdownMulti
                                                label={t("visitreports.filters.territoryID")}
                                                options={
                                                    globalFilters?.territories?.map((emp: any) => ({
                                                        value: String(emp.territory_id),
                                                        label: emp.territory_identifier,
                                                    })) || []
                                                }
                                                selectedValues={territoryId}
                                                onChange={setTerritoryId}
                                                onClose={handleFiltersUpdate}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t(
                                                    "visitreports.filters.selectTerritoryID"
                                                )}
                                            />
                                        </div> */}

                                        <div className="w-1/2">
                                            <DropdownMulti
                                                label={t("visitreports.filters.channelID")}
                                                options={
                                                    globalFilters?.channels?.map((emp: any) => ({
                                                        value: emp.id,
                                                        label: emp.name,
                                                    })) || []
                                                }
                                                selectedValues={channelId}
                                                onClose={handleFiltersUpdate}
                                                onChange={setChannelId}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t("visitreports.filters.selectChannelID")}
                                            />
                                        </div>
                                        <div className="w-1/2">
                                            <DropdownMulti
                                                label={t("ActivityReport.employeeName")}
                                                options={
                                                    globalFilters?.employees.map((emp: any) => ({
                                                        value: emp.id,
                                                        label: emp.name_eng + " (" + emp.id + ")",
                                                    })) || []
                                                }
                                                selectedValues={selectedEmpId}
                                                onClose={handleFiltersUpdate}
                                                onChange={setSelectedEmpId}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t("ActivityReport.employeeName")}
                                                searchable={true}
                                            />
                                        </div>
                                    </div>
                                    {/* <div>
                                        <div className="w-full">
                                            <DropdownMulti
                                                label={t("visitreports.filters.routeID")}
                                                options={
                                                    globalFilters?.routes?.map((emp: any) => ({
                                                        value: `${emp.route_id}`,
                                                        label: emp.route_identifier,
                                                    })) || []
                                                }
                                                selectedValues={routeId}
                                                onClose={handleFiltersUpdate}
                                                onChange={setRouteId}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t("visitreports.filters.selectRouteID")}
                                            />
                                        </div>
                                    </div> */}
                                    <div>

                                        <div >
                                            <Dropdown
                                                label={t("visitreports.filters.userType")}
                                                options={
                                                    globalFilters?.user_types.map((emp: any) => ({
                                                        value: emp,
                                                        label: emp,
                                                    })) || []
                                                }
                                                selectedValue={userType}
                                                onChange={setUserType}
                                                disabled={selectedRegion.length === 0 || loadingFilter}
                                                placeholder={t("visitreports.filters.selectUserType")}
                                            />
                                        </div>
                                    </div>

                                    {/* Creation Date */}
                                    <div className="date-range-picker space-y-2">
                                        <div className="flex gap-4 justify-between w-full">
                                            <div className="w-full">
                                                <label className="block text-10 text-gray-700 mb-1">
                                                    {t("visitreports.filters.startDate")}:
                                                </label>
                                                <input
                                                    type="date"
                                                    className="rounded p-2 border-2 border-gray-400 w-full"
                                                    value={startDate}
                                                    onChange={handleStartDateChange}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                    max={new Date(endDate).toISOString().split("T")[0]}
                                                    min={(() => {
                                                      const end = new Date(endDate);
                                                      const minDate = new Date(end);
                                                      minDate.setDate(end.getDate() - 30);
                                                      return minDate > new Date(0) ? minDate.toISOString().split("T")[0] : '1970-01-01';
                                                    })()}
                                                />
                                            </div>
                                            <div className="w-full">
                                                <label className="block text-10 text-gray-700 mb-1">
                                                    {t("visitreports.filters.endDate")}:
                                                </label>
                                                <input
                                                    type="date"
                                                    className="rounded p-2 border-2 border-gray-400 w-full"
                                                    max={new Date().toISOString().split("T")[0]}
                                                    min={new Date(startDate).toISOString().split("T")[0]}
                                                    value={endDate}
                                                    onChange={handleEndDateChange}
                                                    onKeyDown={(e) => e.preventDefault()}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div>
                                        <TimeFrameSelector
                                            customClass={"w-full border border-gray-300 rounded p-2"}
                                            setSelectTimeFrame={setSelectTimeFrame}
                                            timeFrame={timeFrame}
                                            setStartDate={setStartDate}
                                            setEndDate={setEndDate}
                                        />
                                    </div>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex justify-between mt-4">
                                    <Button
                                        onClick={handleClearFilters}
                                        label={t("visitreports.filters.clearFilter")}
                                        type="grey"
                                    />
                                    <Button
                                        onClick={() => handleApply(sortType)}
                                        label={t("visitreports.filters.applyFilter")}
                                        type="purple"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div className="h-[calc(100vh-200px)] md:h-[calc(100vh-125px)] overflow-auto page-container p-2 pt-0 scrollbar scrollbar-thin">
                    <table className="min-w-full bg-white border border-black-200 table-auto border-separate border-spacing-0">
                        <thead className="bg-gray-200 sticky top-[0px] z-20">
                            <tr>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.id")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.createdAt")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.updatedAt")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.nameArb1")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.nameArb2")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.nameArb3")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.nameEng")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.mobileNo")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.alternateMobileNo")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.email")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.building")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.street")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.city")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.district")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.postcode")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.latitude")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.longitude")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.vatNumber")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.vatImgPath")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.crNumber")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.crImgPath")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.shopLicNumber")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.shopLicImgPath")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.routeId")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.channelId")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.divisionId")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.presellerId")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.paymentTerm")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.comment")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.shopBoardImgPath")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.visitDay")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.visitFrequency")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.sun")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.mon")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.tue")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.wed")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.thu")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.sat")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.approvalRequestId")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.sapCustomerId")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.status")}
                                </th>

                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.channelname")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.divisionname")}
                                </th>
                                <th className="px-4 py-3 border border-gray-300 text-left text-13 font-bold text-black-500 whitespace-normal w-24">
                                    {t("supervisorCustomerCreationDetails.presellername")}
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {employees?.items?.length > 0 &&
                                !loading &&
                                employees.items.map((employee: any, index: number) => (
                                    <tr
                                        key={employee.id}
                                        className="text-16  hover:bg-gray-50"
                                    >
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.id}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.created_at ? moment(employee.created_at).format("hh:mm A") : "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.updated_at ? moment(employee.created_at).format("hh:mm A") : "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.name_arb1 || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.name_arb2 || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.name_arb3 || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.name_eng || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.mobile_number || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.alternate_mobile_number || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.email || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {`${employee.building ?? ""}, ${employee.street ?? ""}, ${employee.city ?? ""}, ${employee.district ?? ""}, ${employee.postcode ?? ""}`}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.street ?? "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.city ?? "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.district ?? "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.postcode ?? "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.latitude ?? "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.longitude ?? "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.vat_number ?? "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap flex items-center justify-center">
                                            <img
                                                src={Eye}
                                                onClick={() => {
                                                    handleOpenPopup({
                                                        actualImage: employee.vat_image_url,
                                                        imageType: "VAT Certificate",
                                                    });
                                                }}
                                                alt="View VAT"
                                                className="h-5 w-5 sm:h-6 sm:w-6 cursor-pointer"
                                            />
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.cr_number || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap flex items-center justify-center">
                                            <img
                                                src={Eye}
                                                onClick={() => {
                                                    handleOpenPopup({
                                                        actualImage: employee.cr_image_url,
                                                        imageType: "CR Certificate",
                                                    });
                                                }}
                                                alt="View CR"
                                                className="h-5 w-5 sm:h-6 sm:w-6 cursor-pointer"
                                            />
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.shop_licence_number || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap flex items-center justify-center">
                                            <img
                                                src={Eye}
                                                onClick={() => {
                                                    handleOpenPopup({
                                                        actualImage: employee.shop_licence_image_url,
                                                        imageType: "Shop License",
                                                    });
                                                }}
                                                alt="Shop License"
                                                className="h-5 w-5 sm:h-6 sm:w-6 cursor-pointer"
                                            />
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.route_id || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.channel_id || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.division_id || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.preseller_id || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.payment_term || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.comment || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap flex items-center justify-center">
                                            <img
                                                src={Eye}
                                                onClick={() => {
                                                    handleOpenPopup({
                                                        actualImage: employee.shop_board_image_url,
                                                        imageType: "Shop Board",
                                                    });
                                                }}
                                                alt="Shop Board"
                                                className="h-5 w-5 sm:h-6 sm:w-6 cursor-pointer"
                                            />
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.visit_day || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.visit_frequency || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.sunday || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.monday || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.tuesday || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.wednesday || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.thrusday || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.saturday || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.sap_request_id || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.sap_customer_id || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.status || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.channel_name || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.division_name || "-"}
                                        </td>
                                        <td className="px-4 py-3 border text-black-600 whitespace-nowrap">
                                            {employee.preseller_name || "-"}
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    {employees?.items?.length === 0 && !loading && (
                        <>
                            <div className="px-4 py-3 border text-center text-black-600 w-full flex items-center justify-center">
                                {t("planogram.noresultsfound")}
                            </div>
                        </>
                    )}
                    {loading && <Loader />}
                    {isPopupOpen && (
                        <PlanogramPopup
                            actualImage={imgData?.actualImage}
                            processedImage={null} // if not applicable
                            comparisonImage={null}
                            imageType={imgData?.imageType}
                            onClose={handleClosePopup}
                        />
                    )}
                </div>
                <div className="sm:hidden bg-white p-2 border-t-2 mt-auto">
                    <PaginationComponent
                        totalCount={employees?.total}
                        itemsPerPage={employees?.size}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                    />
                </div>
            </div>
        </DashboardPage>
    );
};

export default CustomerCreationReport;
